import types from '../types';

/**
 * @param {types.AdvancedFilter[]} filters
 * @returns {?Array}
 */
const getRequestBodyFromAdvancedFilters = filters => {
    if (!filters || !Array.isArray(filters) || !filters.length) {
        return null;
    }

    return filters.reduce((acc, curr) => [...acc, `${curr.id}:${curr.value}`], []);
};

export default getRequestBodyFromAdvancedFilters;
